import React from "react";

function ExportAndPrintIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7857 5.78516H3.64286C3.07454 5.78516 2.52949 6.01092 2.12763 6.41278C1.72576 6.81465 1.5 7.35969 1.5 7.92801V19.3566C1.5 19.9249 1.72576 20.4699 2.12763 20.8718C2.52949 21.2737 3.07454 21.4994 3.64286 21.4994H15.0714C15.6397 21.4994 16.1848 21.2737 16.5867 20.8718C16.9885 20.4699 17.2143 19.9249 17.2143 19.3566V12.2137"
        stroke="#424242"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M11.5 11.5L20.5914 2.40857M14.3571 1.5H21.5V8.64286"
        stroke="#424242"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ExportAndPrintIcon;
